app.ui.registerUi('carousel', function(app) {
	
	var helpers = app.helpers.funcs;

	return {

		implementationExists: function() {
			return jQuery.fn.jdaSlideshow ? true : false;
		},

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function ($scope) {
            if (!this.implementationExists()) return;
			var $ssElems = helpers.resolveScope('ul.jda-ss-seed', $scope);
            $ssElems.each(function (k, ssElem) {
                var $ssElem = $(ssElem);
                var options = {
                    waitDuration: 0,
                    addGlobalEventFunction: function (eventKey, func) {
                        var appEventKey;
                        if (eventKey == 'resize') appEventKey = EVENT_NAME__GENERAL__RESIZE;
                        if (eventKey == 'scroll') appEventKey = EVENT_NAME__GENERAL__SCROLL;
                        app.globalEventRegistry.addListener(appEventKey, func);
                    }
                };

                var possibleOptions = {
                    prevSlideHelpText: $ssElem.data('prev-slide-help-text'),
                    nextSlideHelpText: $ssElem.data('next-slide-help-text'),
                    defaultAltText: $ssElem.data('default-alt-text'),
                    sectionTitleText: $ssElem.data('section-title-text'),
                    mainImageText: $ssElem.data('main-image-text'),
                    openImageText: $ssElem.data('open-image-text')
                };

                Object.keys(possibleOptions).forEach(function (k) {
                    var v = possibleOptions[k];
                    if (v) {
                        options[k] = v;
                    }
                });

                $ssElem.jdaSlideshow(options);
            });
		}
	};
});